import initializeComponent from 'Shared/react-initialize';
import { ChakraDefaultProvider } from 'Shared/chakra-provider';
import { ComponentProps, ComponentType } from 'react';

// Infer from the component, not from its props: ComponentType<T> puts T in a
// parameter position, so TS resolved it to the constraint and a typed
// component came back out of the wrapper accepting no props at all.
function Initializer<C extends ComponentType<any>>(Component: C) {
   return (props: ComponentProps<C>) => (
      <ChakraDefaultProvider>
         <Component {...props} />
      </ChakraDefaultProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
